import React, { createContext, useContext, useMemo } from 'react'
import type { SortDirection } from '../types/access'

export type ListFilterValue = string | number | boolean | undefined
export interface ListViewState {
  page: number
  pageSize: number
  search: string
  sortBy: string
  sortDir: SortDirection
  filters: Record<string, ListFilterValue>
}

interface ListScope {
  scopeKey: string | null
  // Query controls only. Never cache records, authorization or action selections.
  views: Map<string, ListViewState>
  activePersonalViews: Map<string, string>
}
const AdminListStateContext = createContext<ListScope | null>(null)
export const useAdminListState = () => useContext(AdminListStateContext)

function ScopedLists({ scopeKey, children }: React.PropsWithChildren<{ scopeKey: string | null }>) {
  const value = useMemo(() => ({ scopeKey, views: new Map<string, ListViewState>(), activePersonalViews: new Map<string, string>() }), [scopeKey])
  return <AdminListStateContext.Provider value={value}>{children}</AdminListStateContext.Provider>
}

/** A verified identity/access change discards query memory and mounted panel state. */
export function AdminListStateProvider({ scopeKey, children }: React.PropsWithChildren<{ scopeKey: string | null }>) {
  return <ScopedLists key={scopeKey ?? 'unresolved'} scopeKey={scopeKey}>{children}</ScopedLists>
}
